<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.departmentfeepaydetail_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
} from '@/api/v4ward/department/departmentfeepaydetail';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        column: [
          {
            label: '收费明细表ID',
            prop: 'id',
            rules: [
              {
                required: true,
                message: '请输入收费明细表ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '租户收费主表ID',
            prop: 'departmentFeePayId',
            rules: [
              {
                required: true,
                message: '请输入租户收费主表ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '公寓ID',
            prop: 'departmentId',
            rules: [
              {
                required: true,
                message: '请输入公寓ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '费项设置表ID',
            prop: 'itemsetId',
            rules: [
              {
                required: true,
                message: '请输入费项设置表ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '费用种类',
            prop: 'feeSort',
            rules: [
              {
                required: true,
                message: '请输入费用种类',
                trigger: 'change',
              },
            ],
          },
          {
            label: '自定义费项名称',
            prop: 'defItemset',
            rules: [
              {
                required: true,
                message: '请输入自定义费项名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '费用种类',
            prop: 'payUse',
            rules: [
              {
                required: true,
                message: '请输入费用种类',
                trigger: 'change',
              },
            ],
          },
          {
            label: '账单周期编码',
            prop: 'billcycleNo',
            rules: [
              {
                required: true,
                message: '请输入账单周期编码',
                trigger: 'change',
              },
            ],
          },
          {
            label: '账单开始日期',
            prop: 'startDate',
            rules: [
              {
                required: true,
                message: '请输入账单开始日期',
                trigger: 'change',
              },
            ],
          },
          {
            label: '账单结束日期',
            prop: 'endDate',
            rules: [
              {
                required: true,
                message: '请输入账单结束日期',
                trigger: 'change',
              },
            ],
          },
          {
            label: '周期数',
            prop: 'cycleNum',
            rules: [
              {
                required: true,
                message: '请输入周期数',
                trigger: 'change',
              },
            ],
          },
          {
            label: '理论金额',
            prop: 'calAmount',
            rules: [
              {
                required: true,
                message: '请输入理论金额',
                trigger: 'change',
              },
            ],
          },
          {
            label: '滞纳金',
            prop: 'delayAmount',
            rules: [
              {
                required: true,
                message: '请输入滞纳金',
                trigger: 'change',
              },
            ],
          },
          {
            label: '减免金额',
            prop: 'derateAmount',
            rules: [
              {
                required: true,
                message: '请输入减免金额',
                trigger: 'change',
              },
            ],
          },
          {
            label: '账户抵扣金额',
            prop: 'accountpayAmount',
            rules: [
              {
                required: true,
                message: '请输入账户抵扣金额',
                trigger: 'change',
              },
            ],
          },
          {
            label: '优惠券抵扣金额',
            prop: 'couponAmount',
            rules: [
              {
                required: true,
                message: '请输入优惠券抵扣金额',
                trigger: 'change',
              },
            ],
          },
          {
            label: '应收金额',
            prop: 'shouldAmount',
            rules: [
              {
                required: true,
                message: '请输入应收金额',
                trigger: 'change',
              },
            ],
          },
          {
            label: '实收金额',
            prop: 'payAmount',
            rules: [
              {
                required: true,
                message: '请输入实收金额',
                trigger: 'change',
              },
            ],
          },
          {
            label: '付款时间',
            prop: 'payTime',
            rules: [
              {
                required: true,
                message: '请输入付款时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '收费备注',
            prop: 'payRemark',
            rules: [
              {
                required: true,
                message: '请输入收费备注',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注1',
            prop: 'remark1',
            rules: [
              {
                required: true,
                message: '请输入备注1',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注2',
            prop: 'remark2',
            rules: [
              {
                required: true,
                message: '请输入备注2',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注3',
            prop: 'remark3',
            rules: [
              {
                required: true,
                message: '请输入备注3',
                trigger: 'change',
              },
            ],
          },
          {
            label: '版本',
            prop: 'version',
            rules: [
              {
                required: true,
                message: '请输入版本',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.departmentfeepaydetail_add, false),
        viewBtn: this.vaildData(this.permission.departmentfeepaydetail_view, false),
        delBtn: this.vaildData(this.permission.departmentfeepaydetail_delete, false),
        editBtn: this.vaildData(this.permission.departmentfeepaydetail_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
